import { ShoppingCartService } from 'src/app/gamification/marketplace/agent-side/services/shopping-cart.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class ThumbnailSlideService {

  constructor() { }
  private screenWidth: number;
  private screenHeight: number;
  private screenWidthPrev: number;
  private screenHeightPrev: number;
  private buttonleft: boolean;
  private buttonRight: boolean;
  private products = [];

  public getButtonleft() {
    return  this.buttonleft;
  }

  public getButtonRight() {
    return  this.buttonRight;
  }

  public getScreenHeight() {
    return  this.screenHeight;
  }

  public getScreenWidth() {
    return  this.screenWidth;
  }

  public setButtonleft(buttonleft) {
    this.buttonleft = buttonleft;
  }

  public setButtonRight(buttonRight) {
    this.buttonRight = buttonRight;
  }

  public getProducts() {
    return  this.products;
  }
    
  public disableSliderBtn(imagesCount: number) {
    let imagesContainer = this.screenWidth < 1283 ? 3 : 4;;
    imagesContainer = this.screenWidth > 1536 ? 5 : imagesContainer;

    if (imagesCount > imagesContainer) {
        this.buttonleft = true;
        this.buttonRight = false;
    } else {
        this.buttonleft = true;
        this.buttonRight = true;
    }
  } 

  changeResolution(product, imagesCount: number) {
    let imagesContainer = this.screenWidth < 1283 ? 3 : 4;
    imagesContainer = this.screenWidth > 1536 ? 5 : imagesContainer;    
    if (product.scrollLeft <= 0 || !product) {
        this.disableSliderBtn(imagesCount);
    }
    if (product.scrollLeft > ( (48 * (imagesCount - imagesContainer)) - 10 )) {
        this.buttonleft = false;
        this.buttonRight = true;
        product.buttonleft = false;
        product.buttonRight = true;
    } else {
        this.buttonleft = false;
        this.buttonRight = false;
        product.buttonleft = false;
        product.buttonRight = false;
    }
    if (imagesCount <= imagesContainer) {
        this.buttonleft = true;
        this.buttonRight = true;
        this.deleteProduct(product.id);
    }   
  }

  deleteProduct(productID) {
    const index = this.products.findIndex(product => product.id === productID);
    if (index !== -1) {
        this.products.splice(index, 1);
    }     
  }

  private productExist(productID, scrollLeft: number) {
    const product = this.products.find(product => product.id === productID);
    if (!product) {
        let imagesContainer = this.screenWidth < 1283 ? 3 : 4;
        imagesContainer = this.screenWidth > 1536 ? 5 : imagesContainer;
        this.products.push({ id: productID, buttonleft: this.buttonleft, buttonRight: this.buttonRight, resolution: this.screenWidth, scrollLeft: scrollLeft });
    } else {
        product.buttonleft = this.buttonleft;
        product.buttonRight = this.buttonRight;
        product.scrollLeft = scrollLeft;
    }
  }
  public slideLeft(productID) {
    const slider = document.getElementById(`slider_${productID}`);
    slider.scrollLeft -= 48;
    this.buttonRight = false;
    this.buttonleft = slider.scrollLeft === 0;
    slider.scrollLeft === 0 ? this.deleteProduct(productID) : this.productExist(productID, slider.scrollLeft);
  }

 public slideRight(productID, images: number) {
    const slider = document.getElementById(`slider_${productID}`);
    slider.scrollLeft += 48.4;
    this.buttonleft = false;
    let imagesContainer = this.screenWidth < 1283 ? 3 : 4;
    imagesContainer = this.screenWidth > 1536 ? 5 : imagesContainer;
    const withContainer = ((images * 48)- imagesContainer * 48 );
    if (withContainer === slider.scrollLeft || withContainer === slider.scrollLeft + 4) {
        this.buttonRight = true;
    }
    this.productExist(productID, slider.scrollLeft);
  }
  
  public updateResolution(): void {
    this.screenWidthPrev = this.screenWidth? this.screenWidth : parseInt(window.innerWidth.toString(), 10);
    this.screenHeightPrev= this.screenHeight? this.screenHeight : parseInt(window.innerWidth.toString(), 10);
    this.screenWidth = parseInt(window.innerWidth.toString(), 10);
    this.screenHeight = parseInt(window.innerHeight.toString(), 10);
  }
}
